module.exports = __webpack_public_path__ + "img/prize1_active.4e74b12.png";